'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventEmitter, NodeWebSocketClient, debug, isBrowser;

isBrowser = function isBrowser() {
  return !(typeof process !== 'undefined' && process.execPath && process.execPath.indexOf('node') !== -1);
};

EventEmitter = require('events').EventEmitter;

if (!isBrowser()) {
  debug = require('debug')('fbp-protocol-client:platform');
  // Simple compatibility layer between node.js WebSocket client and native browser APIs
  // Respects events: open, close, message, error
  // Note: no data is passed with open and close events
  NodeWebSocketClient = function (_EventEmitter) {
    _inherits(NodeWebSocketClient, _EventEmitter);

    function NodeWebSocketClient(address, protocol) {
      _classCallCheck(this, NodeWebSocketClient);

      var WebSocketClient;

      var _this = _possibleConstructorReturn(this, (NodeWebSocketClient.__proto__ || Object.getPrototypeOf(NodeWebSocketClient)).call(this));

      WebSocketClient = require('websocket').client;
      _this.client = new WebSocketClient(); // the real client
      _this.connection = null;
      _this.client.on('connectFailed', function (error) {
        return _this.emit('error', error);
      });
      _this.client.on('connect', function (connection) {
        if (_this.connection) {
          debug('WARNING: multiple connections for one NodeWebSocketClient');
        }
        _this.connection = connection;
        connection.on('error', function (error) {
          _this.connection = null;
          return _this.emit('error', error);
        });
        connection.on('close', function () {
          _this.connection = null;
          return _this.emit('close');
        });
        connection.on('message', function (message) {
          message.data = message.utf8Data;
          return _this.emit('message', message);
        });
        return _this.emit('open');
      });
      _this.client.connect(address, protocol);
      return _this;
    }

    _createClass(NodeWebSocketClient, [{
      key: 'addEventListener',
      value: function addEventListener(event, listener, capture, wantsUntrusted) {
        return this.on(event, listener);
      }
    }, {
      key: 'close',
      value: function close() {
        if (!this.connection) {
          return;
        }
        this.connection.close();
        return this.connection = null;
      }
    }, {
      key: 'send',
      value: function send(msg) {
        return this.connection.sendUTF(msg);
      }
    }]);

    return NodeWebSocketClient;
  }(EventEmitter);
}

module.exports = {
  isBrowser: isBrowser,
  EventEmitter: EventEmitter,
  WebSocket: isBrowser() ? window.WebSocket : NodeWebSocketClient
};